<template>
    <div class="AddToCart">
        <div v-loading="loading">
            <slot v-bind="this" />
        </div>
        <span v-if="error" class="invalid-feedback d-block">{{ error }}</span>
        <b-modal class="AddToCart__modal" @hidden="handleAlertHidden" ref="alert" data-legacy>
            <div class="row align-items-center">
                <div class="col-2 pr-0">
                    <slot name="ok-icon"></slot>
                </div>
                <div class="col">
                    <div class="alert alert-info m-0">
                        Cet article a bien été ajouté à votre panier. <br>({{qty}}x {{ product.name }})
                    </div>
                </div>
            </div>
            <div slot="modal-footer" class="d-flex justify-content-center justify-content-sm-end flex-wrap">
                <button class="btn btn-secondary mr-2 mb-2 mb-sm-0" @click="hideAlert">continuer</button>
                <a :href="cartUrl" class="btn btn-primary mb-2 mb-sm-0">
                   <span v-if="$slots['cart-icon']" class="mr-1"><slot name="cart-icon"></slot></span> consulter le panier
                </a>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import { BModal } from 'bootstrap-vue';

    export default {
        components: {
            BModal,
        },
        props: {
            initialQuantity: {
                type: Number,
                default: 1
            },
            product: Object, // { name }
            endpoint: String,
            cartUrl: String
        },
        data() {
            return {
                qty: this.initialQuantity,
                error: null,
                loading: false
            }
        },
        methods: {
            handleClicked() {
                this.loading = true;
                this.$store.dispatch('cart/addProduct', {
                    endpoint: this.endpoint,
                    qty: this.qty
                }).then(() => {
                    this.$refs.alert.show();
                }).catch(error => {
                    const { data } = error.response;
                    this.error = data.errors.qty[0]
                }).finally(()=>{
                    this.loading = false;
                })
            },
            handleAlertHidden() {
                this.qty = this.initialQuantity;
            },
            handleQuantityChanged(qty) {
                this.qty = qty;
                this.error = null;
            },
            hideAlert() {
                this.$refs.alert.hide();
            },
        }
    }
</script>
